import {
  getApiV1ThreeLetterCodePublicPrefectures,
  getGetApiV1ThreeLetterCodePublicPrefecturesKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePublicPrefectures200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  threeLetterCode: string;
};

type IUseGetPublicPrefectures = (args: Args) => {
  data: GetApiV1ThreeLetterCodePublicPrefectures200;
};

/**
 * 都道府県一覧を取得するカスタムフック（公開エンドポイント）
 *
 * GET /api/v1/{threeLetterCode}/public/prefectures を使用（認証不要）。
 * Prefecture.code（JIS 2桁）を value、Prefecture.name を label として使用する。
 *
 * @param threeLetterCode - パートナーを識別する3文字コード
 */
export const useGetPublicPrefectures: IUseGetPublicPrefectures = ({ threeLetterCode }) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePublicPrefecturesKey(threeLetterCode),
    () => getApiV1ThreeLetterCodePublicPrefectures(threeLetterCode),
    { suspense: true }
  );

  return { data };
};
